import { ChartColors } from '@nimbus-library/features/charts/models/chart-colors';

export interface IHandledRatioColors {
  0: string;
  0.05: string;
  0.1: string;
  0.15: string;
  0.2: string;
  0.25: string;
  0.3: string;
  0.35: string;
  0.4: string;
  0.45: string;
  0.5: string;
  0.55: string;
  0.6: string;
  0.65: string;
  0.7: string;
  0.75: string;
  0.8: string;
  0.85: string;
  0.9: string;
  0.95: string;
  1: string;
}

export class DefaultHandledRatioColors implements IHandledRatioColors {
  public 0 = ChartColors.BittersweetRed;
  public 0.05 = ChartColors.BittersweetRedFawnOrangeTransition;
  public 0.1 = ChartColors.BittersweetRedFawnOrangeTransition;
  public 0.15 = ChartColors.BittersweetRedFawnOrangeTransition;
  public 0.2 = ChartColors.BittersweetRedFawnOrangeTransition;
  public 0.25 = ChartColors.BittersweetRedFawnOrangeTransition;
  public 0.3 = ChartColors.BittersweetRedFawnOrangeTransition;
  public 0.35 = ChartColors.FawnOrange;
  public 0.4 = ChartColors.FawnOrange;
  public 0.45 = ChartColors.FawnOrange;
  public 0.5 = ChartColors.FawnOrange;
  public 0.55 = ChartColors.FawnOrange;
  public 0.6 = ChartColors.FawnOrange;
  public 0.65 = ChartColors.FawnOrangeMountainMeadowTransition;
  public 0.7 = ChartColors.FawnOrangeMountainMeadowTransition;
  public 0.75 = ChartColors.FawnOrangeMountainMeadowTransition;
  public 0.8 = ChartColors.FawnOrangeMountainMeadowTransition;
  public 0.85 = ChartColors.FawnOrangeMountainMeadowTransition;
  public 0.9 = ChartColors.FawnOrangeMountainMeadowTransition;
  public 0.95 = ChartColors.FawnOrangeMountainMeadowTransition;
  public 1 = ChartColors.MountainMeadow;
}

export class DarkHandledRatioColors implements IHandledRatioColors {
  public 0 = ChartColors.BittersweetRedDark;
  public 0.05 = ChartColors.BittersweetRedFawnOrangeTransitionDark;
  public 0.1 = ChartColors.BittersweetRedFawnOrangeTransitionDark;
  public 0.15 = ChartColors.BittersweetRedFawnOrangeTransitionDark;
  public 0.2 = ChartColors.BittersweetRedFawnOrangeTransitionDark;
  public 0.25 = ChartColors.BittersweetRedFawnOrangeTransitionDark;
  public 0.3 = ChartColors.BittersweetRedFawnOrangeTransitionDark;
  public 0.35 = ChartColors.FawnOrangeDark;
  public 0.4 = ChartColors.FawnOrangeDark;
  public 0.45 = ChartColors.FawnOrangeDark;
  public 0.5 = ChartColors.FawnOrangeDark;
  public 0.55 = ChartColors.FawnOrangeDark;
  public 0.6 = ChartColors.FawnOrangeDark;
  public 0.65 = ChartColors.FawnOrangeMountainMeadowTransitionDark;
  public 0.7 = ChartColors.FawnOrangeMountainMeadowTransitionDark;
  public 0.75 = ChartColors.FawnOrangeMountainMeadowTransitionDark;
  public 0.8 = ChartColors.FawnOrangeMountainMeadowTransitionDark;
  public 0.85 = ChartColors.FawnOrangeMountainMeadowTransitionDark;
  public 0.9 = ChartColors.FawnOrangeMountainMeadowTransitionDark;
  public 0.95 = ChartColors.FawnOrangeMountainMeadowTransitionDark;
  public 1 = ChartColors.MountainMeadowDark;
}
